import {FC} from 'react'
import {Controller, Control} from 'react-hook-form'
import type {Schema} from '../schema'

// @ts-ignore
import {AdminFroalaEditorField} from '../../froala/lazy'

import styles from './AdminMailBody.scss'

type MailBodyProps = {
  name: 'adminMailBody' | 'employeeMailBody'
  control: Control<Schema>
  disabled?: boolean
}

export const AdminMailBody: FC<MailBodyProps> = ({name, control, disabled = false}) => {
  return (
    <div className={disabled && styles.disabled}>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <AdminFroalaEditorField
            input={{
              value: field.value,
              onChange: field.onChange,
            }}
            disabled={disabled}
          />
        )}
      />
    </div>
  )
}
